module.exports = __webpack_public_path__ + "static/media/Fairytale Princess.74d4b1f2.jpg";